import { render, staticRenderFns } from "./GetInvoice.vue?vue&type=template&id=12279505&"
import script from "./GetInvoice.vue?vue&type=script&lang=js&"
export * from "./GetInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports